import http from '../api/http';
import fetchInstance from './fetchConfig';
import { env } from '../env'

export default {
  login(pat, callback) { // 登录
    http.post('/v1/venue/login', pat).then(res => {
      callback(res, 'login')
    }).catch(err => {
      callback(err, 'login')
    })
  },
  progress(pat, callback) { // 步骤状态
    http.get(`/v1/home/stepStatus`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },

  sendXero({ params, callback }) { // 发送第三方的code
    http.post(`/v1/xero/bind?code=${params.code}`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  sendDeputy({ params, callback }) { // 发送第三方的code
    http.post(`/v1/deputy/bind?code=${params.code}`, params).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  bindDeputyTrue({ params, callback }) { // 发送第三方的code
    http.post(`/v1/deputy/complete`, params).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  getDeputyOption({ params, callback }) { //
    http.get(`/v1/deputy/area/${params.companyId}?companyId=${params.companyId}`, params).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  sendTanda({ params, callback }) { // 发送第三方的code
    http.post(`/v1/tanda/tanda-bind?code=${params.code}&scope=roster+timesheet+department+user+cost+settings+me`, {
    }).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  bindTandaTrue({ params, callback }) { // 发送第三方的code
    http.post(`/v1/tanda/tanda-complete`, params).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  getTandaOption({ params, callback }) { //
    http.get(`/v1/tanda/tanda-area/${params.companyId}`, params).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  getRent(pat, callback) { // 获取租金
    http.post('/v1/venue/venueRent', pat).then(res => {
      callback(res, 'getRent')
    }).catch(err => {
      callback(err, 'getRent')
    })
  },
  setRent(pat, callback) { // 设置租金
    http.put('/v1/venue/updateRent', pat).then(res => {
      callback(res, 'setRent')
    }).catch(err => {
      callback(err, 'setRent')
    })
  },
  getVenueInfo(pat, callback) { // 获取场馆信息
    http.post('/v1/venue/venueInfo', pat).then(res => {
      callback(res, 'getVenueInfo')
    }).catch(err => {
      callback(err, 'getVenueInfo')
    })
  },
  setVenueInfo(pat, callback) { // 设置场馆信息
    http.put('/v1/venue/updateVenueInfo', pat).then(res => {
      callback(res, 'setVenueInfo')
    }).catch(err => {
      callback(err, 'setVenueInfo')
    })
  },

  getStreanList(pat, callback) { // 获取额外收入列表
    http.post('/v1/revenue/list', pat).then(res => {
      callback(res, 'getStreanList')
    }).catch(err => {
      callback(err, 'getStreanList')
    })
  },
  addStreanInfo(pat, callback) { // 添加额外收入
    http.post('/v1/revenue/save', pat).then(res => {
      callback(res, 'addStreanInfo')
    }).catch(err => {
      callback(err, 'addStreanInfo')
    })
  },
  editStreanInfo(pat, callback) { // 修改额外收入
    http.put('/v1/revenue/update', pat).then(res => {
      callback(res, 'editStreanInfo')
    }).catch(err => {
      callback(err, 'editStreanInfo')
    })
  },

  getPlatformFeesList(pat, callback) { // 获取扣款列表
    http.post('/v1/strip/platformFeesList', pat).then(res => {
      callback(res, 'getPlatformFeesList')
    }).catch(err => {
      callback(err, 'getPlatformFeesList')
    })
  },
  getCardInfo(pat, callback) { // 获取卡信息
    http.post('/v1/strip/getCardInfo', pat).then(res => {
      callback(res, 'getCardInfo')
    }).catch(err => {
      callback(err, 'getCardInfo')
    })
  },
  editCardInfo(pat, callback) { // 修改卡信息
    http.post('/v1/strip/editCard', pat).then(res => {
      callback(res, 'editCardInfo')
    }).catch(err => {
      callback(err, 'editCardInfo')
    })
  },

  getWeeklyForecastList(pat, callback) { // 获取Deputy Roster中的 Weekly Forecast与列表
    http.post('/v1/venue/weeklyForecast', pat).then(res => {
      callback(res, 'getWeeklyForecastList')
    }).catch(err => {
      callback(err, 'getWeeklyForecastList')
    })
  },
  getLabourHistory(pat, callback) { // 获取Labour History 工时和薪资
    http.post('/v1/venue/labourHistory', pat).then(res => {
      callback(res, 'getLabourHistory')
    }).catch(err => {
      callback(err, 'getLabourHistory')
    })
  },

  getEmployeeList(pat, callback) { // 获员工列表
    http.post('/v1/venue/employee/list', pat).then(res => {
      callback(res, 'getEmployeeList')
    }).catch(err => {
      callback(err, 'getEmployeeList')
    })
  },
  addEmployee(pat, callback) { // 新增员工
    http.post('/v1/venue/employee/add', pat).then(res => {
      callback(res, 'addEmployee')
    }).catch(err => {
      callback(err, 'addEmployee')
    })
  },
  editEmployee(pat, callback) { // 修改员工
    http.put('/v1/venue/employee/update', pat).then(res => {
      callback(res, 'editEmployee')
    }).catch(err => {
      callback(err, 'editEmployee')
    })
  },
  getEmployee(pat, callback) { // 获取员工
    http.post(`/v1/venue/employee/info/${pat.id}`, pat).then(res => {
      callback(res, 'getEmployee')
    }).catch(err => {
      callback(err, 'getEmployee')
    })
  },
  delEmployee(pat, callback) { // 删除员工
    http.delete(`/v1/venue/employee/delete/${pat.id}`, pat).then(res => {
      callback(res, 'delEmployee')
    }).catch(err => {
      callback(err, 'delEmployee')
    })
  },
  changeEmployeeState(pat, callback) { // 切换员工状态
    http.put(`/v1/venue/employee/updateActive`, pat).then(res => {
      callback(res, 'changeEmployeeState')
    }).catch(err => {
      callback(err, 'changeEmployeeState')
    })
  },

  getTargetRoster(pat, callback) { // 获取期望毛利润
    http.post(`/v1/home/targetRoster`, pat).then(res => {
      callback(res, 'getTargetRoster')
    }).catch(err => {
      callback(err, 'getTargetRoster')
    })
  },
  saveTargetRoster(pat, callback) { // 保存期望毛利润
    http.post(`/v1/home/saveProfitTarget`, pat).then(res => {
      callback(res, 'saveTargetRoster')
    }).catch(err => {
      callback(err, 'saveTargetRoster')
    })
  },
  unlinkDeputy(pat, callback) { // 解绑depty
    console.log('pat: ', pat);
    http.put(`/v1/deputy/revocation`, pat).then(res => {
      callback(res, 'unlinkDeputy')
    }).catch(err => {
      callback(err, 'unlinkDeputy')
    })
  },
  unlinkTanda(pat, callback) { // 解绑tanda
    http.put(`/v1/tanda/tanda-revocation`, pat).then(res => {
      callback(res, 'unlinkTanda')
    }).catch(err => {
      callback(err, 'unlinkTanda')
    })
  },
  unlinkXero(pat, callback) { // 解绑xero
    http.put(`/v1/xero/revocation`, pat).then(res => {
      callback(res, 'unlinkXero')
    }).catch(err => {
      callback(err, 'unlinkXero')
    })
  },
  addHoliday({ params, callback }) { // 新增假期
    http.post(`/v1/venue/holidays`, params).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  queryHoliday({ callback }) { // 假期列表
    http.get(`/v1/venue/holidays`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  alterHoliday({ params, callback }) { // 假期修改
    http.put(`/v1/venue/holidays`, params).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  deleteHoliday({ params, callback }) { // 假期删除
    http.delete(`/v1/venue/holidays/${params}`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  manualCogsList({ pat, callback }) { // 查询COGS成本列表
    http.get(`/v1/venue/manualCogs?pageNum=${pat.pageNum}&pageSize=${pat.pageSize}`, pat).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  editManualCogs(pat, callback) { // 修改COGS成本列表
    http.put(`/v1/venue/manualCogs`, pat).then(res => {
      callback(res, 'editManualCogs')
    }).catch(err => {
      callback(err, 'editManualCogs')
    })
  },
  delManualCogsList(pat, callback) { // 清空COGS成本列表
    http.delete(`/v1/venue/manualCogs`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  getTimeList(callback) { // 获取时间列表
    http.get(`/v1/home/optionalList`).then(res => {
      if (res.data && res.data.code == 0) {
        this.setTimeListData(res.data.data)
      }
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  async setTimeListData(data) {
    sessionStorage.setItem('zoneId', data.zoneId)
    sessionStorage.setItem('currentDayOfWeek', data.currentDayOfWeek)
    if (data.currentBusinessDay) {
      sessionStorage.setItem('currentBusinessDay', data.currentBusinessDay)
    }
    
    sessionStorage.setItem('currentWeekIndex', data.currentWeekIndex)
    sessionStorage.setItem('weekStart', data.weekStart);

    // CHECK DASHBOARD V2
    await this.checkDashboardV2();
    await this.checkEosEnable();
  },

  async checkEosEnable() {
      let venueId = sessionStorage.getItem('subVenueId')
      try {
        
        let url = `/eos/v1/venues/${venueId}/enabled`
        let res = await fetchInstance(url)
      
        if (res.status === 200) {
          sessionStorage.setItem('isEosActivated', true)
        } else {
          sessionStorage.setItem('isEosActivated', false)
        }
    
        return res
      } catch (error) {
        sessionStorage.setItem('isEosActivated', false)
        return false
      }
      
  },

  async fetchIntegrations () {
    try {
      const venueId = sessionStorage.getItem('subVenueId')
      let url = `/venue/v1/venues/${venueId}/integrations`

      let res = await fetchInstance(url)
      if (res.status === 200) {   
          return await res.json()
      }
    } catch (error) { 
      return [];
    }

  },

  async checkDashboardV2() {
    if (env.NAME == 'lucas') {
      sessionStorage.setItem('isDashboardV2', false)
      return
    } 
    try {
      let venueId = sessionStorage.getItem('subVenueId')
      let url = `/dashboard/v2/venues/${venueId}/enabled`
      let res = await fetchInstance(url)
      
      if (res.status === 200) {
        sessionStorage.setItem('isDashboardV2', true)
      }
    } catch (err) {
      sessionStorage.setItem('isDashboardV2', false)
    }
  },

  delManualCogs(pat, callback) { // 删除COGS成本列表
    http.delete(`/v1/venue/manualCogs/${pat.id}`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  delRevenueNew(pat, callback) { // 删除收入来源列表
    http.delete(`/v1/revenue/delete/${pat.id}`).then(res => {
      callback(res, 'delRevenueNew')
    }).catch(err => {
      callback(err, 'delRevenueNew')
    })
  },
  getProfitLossList(pat, callback) { // 查询Profit&Loss列表
    http.get(`/v1/venue/profitLoss`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  editProfitLoss(pat, callback) { // 修改Profit&Loss列表
    http.put(`/v1/venue/profitLoss`, pat).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  addProfitLoss(pat, callback) { // 添加Profit&Loss列表
    http.post(`/v1/venue/profitLoss`, pat).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  /*delProfitLossNew(pat,callback){ // 这是现在正式用的接口
      http.delete(`/v1/venue/profitLoss/delete?title=${pat.title}`,pat).then(res => {
          callback(res)
      }).catch(err => {
          callback(err)
      })
  },
  recoveryApi(params, callback){ // 这是现在正式用的接口
      http.put(`/v1/venue/profitLoss/recovery?title=${params.title}`).then(res => {
          callback(res)
      }).catch(err => {
          callback(err)
      })
  },*/
  delProfitLossNew(pat, callback) { // 这是现在沙箱用的接口
    http.delete(`/v1/venue/profitLoss/profitLoss-delete`, pat).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  recoveryApi(params, callback) { // 这是现在沙箱用的接口
    http.put(`/v1/venue/profitLoss/profitLoss-recovery`, params).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  delProfitLoss(pat, callback) { // 删除Profit&Loss列表
    http.delete(`/v1/venue/profitLoss`, pat).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  getSetFlag(pat, callback) { //
    http.get(`/v1/venue/profitLossEdit`, pat).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  getPosListInfo(pat, callback) { //
    http.get(`/v1/venue/posList`, pat).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  updataPin(pat, callback) { //
    http.put(`/v1/venue/update-pin`, pat).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  updataPos(pat, callback) { //
    http.put(`/v1/venue/update-pos?posId=${pat.posId}`, pat).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  delDoshiLink(pat, callback) { //
    http.put(`/doshii/unsubscribed`, pat).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  unsubscribed({ callback }) {
    http.put(`/doshii/unsubscribed`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  areaCompanyInfo({ callback }) {
    http.get(`/v1/deputy/company-info`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  venueInfo({ callback }) {
    http.get(`/v1/deputy/venue-info`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  areaList({ callback, params }) {
    http.get(`/v1/deputy/area/${params}`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  saveInfo({ callback, params }) {
    http.put(`/v1/deputy/company-info`, params).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  areaCompanyInfoTanda({ callback }) {
    http.get(`/v1/tanda/company-info`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  venueTandaInfo({ callback }) {
    http.get(`/v1/tanda/venue-info`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  areaTandaList({ callback, params }) {
    http.get(`/v1/tanda/area-info/${params}`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  saveTandaInfo({ callback, params }) {
    http.put(`/v1/tanda/company-info`, params).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },

  clickBindDoshii({ callback }) {
    http.post(`/v1/home/click-bind-doshii`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  getEmployeeNewList({ callback, params }) {
    http.get(`/v1/venue/employee?pageNum=${params.pageNum}&pageSize=${params.pageSize}`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  addEmployeeNew({ params, callback }) {
    http.post(`/v1/venue/employee`, params).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },

  updateEmployeeNew({ params, callback }) {
    http.put(`/v1/venue/employee`, params).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  deleteEmployeeNew({ params, callback }) {
    http.delete(`/v1/venue/employee/${params}`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  onCost({ callback }) {
    http.get(`/v1/venue/employee/on-cost`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  onCostV2({ callback }) {
    http.get(`/v1/venue/employee/add-on-cost`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  updateCost({ params, callback }) {
    http.post(`/v1/venue/employee/on-cost?onCost=${params}`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  updateCostV2({ params, callback }) {
    http.post(`/v1/venue/employee/add-on-cost?superAnnuationRate=${params}`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  
  appListApi(params, callback) {
    http.get(`/v1/appAccount/account-list?pageNum=${params.pageNum}&pageSize=${params.pageSize}`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  accountAddApi({ params, callback }) {
    http.post(`/v1/appAccount/account-add`, params).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  accountEditApi({ params, callback }) {
    http.put(`/v1/appAccount/account-edit/${params.id}`, { fullName: params.fullName, emailAddress: params.emailAddress }).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  accountDeleteApi({ params, callback }) {
    http.delete(`/v1/appAccount/account-delete/${params.id}`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  bluesheetBindApi({ params, callback }) {
    http.post(`/v1/bluesheet-bind?code=${params.code}`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  getTrackingCategoriesApi({ callback }) {
    http.get(`/v1/bluesheet-getTrackingCategories`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  saveTrackingCategoriesApi({ params, code, callback }) {
    http.post(`/v1/bluesheet-saveTrackingCategories?code=${code}`, params).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },
  bluesheetDisConnectApi({ callback }) {
    http.put(`/v1/bluesheet-disConnect`).then(res => {
      callback(res)
    }).catch(err => {
      callback(err)
    })
  },


  // ===================================

  // settings/set automated report
  async getAutomatedReport() {
    let url = `/v1/venue/report/settings`
    return await http.get(url)
  },

  async setAutomatedReport(payload) {
    let url = `/v1/venue/report/settings`
    return await http.post(url, payload)
  },

  async tandaSuperAnuation({ params, callback }) {
    let url = `/v1/tanda/annuation`

    http.post(url, params).then((res) => {
      callback(res)
    }).catch((err) => {
      callback(err)
    })

  },

  async getKseriesAuthorization(params) {
    let url = `/kseries/authorization?url=${params.url}`
    return await http.get(url)
  },

  async kseriesHandShake(payloads) {
    let url = `/kseries/login`
    return await http.post(url, payloads)
  },

  async kseriesBusinesses(params) {
    let url = `/kseries/businesses`
    // let url = `/kseries/businesses`
    return await http.post(url)
  },

  async kseriesUnlink() {
    let url = `/kseries/unlink`
    return await http.put(url)
  },

  async saveKseriesBusinessLocation(params) {
    let url = `/kseries/selectedBusinessLocation?businessId=${params.businessId}&businessLocationId=${params.businessLocationId}`
    return await http.post(url)
  },

  async kseriesLoadOrders(params) {
    let url = `/kseries/orders?businessLocationId=${params.businessLocationId}&groupBy=accountingGroup`
    return await http.post(url)
  },

  async unlinkHandl() {
    let url = `/v1/handl/unlink`
    const res = await http.delete(url)
    return res
  },

  async initHandl(params) {
    let url = '/v1/home/initializeHandl'
    return await http.post(url, params)
  },

  async initHandlv2(params) {
    let url = '/v1/home/initializeHandlV2'
    return await http.post(url, params)
  },

  async insertHandlGroupAndVenue(params) {
    let url = '/v1/handl/insertHandlGroupAndVenue'
    return await http.post(url, params)
  },

  async getHandlRevenueGroups() {
    let url = '/v1/handl/revenue-groups'
    return await http.get(url)
  },

  async oseriesBind(payloads) {
    let url = `/v1/oseries/bind?code=${payloads.code}`
    return await http.post(url)
  },

  async oseriesRegisters(payloads) {
    let url = `/v1/oseries/select/registers?siteId=${payloads.siteId}`
    return http.get(url)
  },

  async oseriesCategories(payloads) {
    let url = `/v1/oseries/category?siteId=${payloads.siteId}`
    return http.get(url)
  },

  async oseriesComplete(payloads) {
    let url = `/v1/oseries/complete`
    return http.post(url, payloads)
  },

  async oseriesUnbind() {
    let url = `/v1/oseries/unbind`
    return http.put(url)
  },

  async cashRegister(payload, isSend) {
    let url = `/v1/venue/cash_register?isSend=${isSend ? true : false}`

    return http.post(url, payload)
  },

  async get_cashup(dt) {
    let url = `/v1/venue/get_cashup?report_date=${dt}`

    return http.get(url)
  },

  async saveBudgeting(payloads) {
    let url = `/v1/venue/saveBudgeting`

    return http.post(url, payloads)
  },

  async getBudgetingTools() {
    let url = `/v1/venue/getBudgetingTools`

    return http.get(url)
  },

  async getVenueInfoForPeriodic(pat) { // 获取场馆信息
    let url = '/v1/venue/venueInfo'
    return await http.post(url, pat)
  },

  async deleteSchedule(data) {
    let url = '/v1/venue/report/settings/deleteSchedule'
    return await http.post(url, data)
  },

  async saveSchedule(data) {
    let url = '/v1/venue/report/settings/saveSchedule'
    return await http.post(url, data)
  },

  async getSchedules() {
    let url = '/v1/venue/report/settings/getSchedules'
    return await http.get(url)
  },

  async latestWeatherUpdate(payloads) {
    let url = `/v1/weather/${payloads.id}`

    return await http.get(url)
  },

  async updateCard(payloads) {
    let url = `/v1/venue/update-cc?cardNumber=${payloads.cardNumber}&cardName=${payloads.cardName}&expire=${payloads.expire}&cvv=${payloads.cvv}&&monthly_fee=${payloads.monthly_fee}`
    return await http.post(url)
  },

  async tevalisBind(payload) {
    let url = `/v1/tevalis/bind?companyId=${payload.companyId}&devId=${payload.devId}&guid=${payload.guid}`
    return await http.post(url)
  },

  async tevalisUnbind() {
    let url = `/v1/tevalis/unbind`

    return await http.post(url)
  },

  async tevalisCategories(siteId = null) {
    let url = `/v1/tevalis/category?siteId=${siteId}`

    return await http.get(url)
  },

  async tevalisTerminals(siteId = null) {
    let url = `/v1/tevalis/terminals?siteId=${siteId}`

    return await http.get(url)
  },

  async tevalisCompleteBinding(payload) {
    let url = `/v1/tevalis/complete`

    return await http.post(url, payload)
  },

  async xeroJournal(payload) {
    let url = `/v1/xero/journals/report?date=${payload.date}`
    return await http.get(url)
  },


  async xeroJournals(payload) {
    let url = `/v1/xero/journals?pageNum=${payload.pageNum}&pageSize=10`
    return await http.get(url)
  },

  async xeroAccounts(payload) {
    let url = `/v1/xero/accounts/list?pageNum=${payload.pageNum}&pageSize=10`
    return await http.get(url)
  },

  async saveXeroJournal(payloads) {
    let url = `/v1/xero/journals/report`

    return await http.post(url, payloads)
  },

  async xeroAccountList() {
    let url = `/v1/xero/accounts`

    return await http.get(url)
  },

  async redcatGenerateToken(payloads) {
    let url = `https://${payloads.subdomain}.redcatcloud.com.au/api/v1/login`
    var data = {
      username: payloads.username,
      psw: payloads.password,
      auth_type: 'U'
    }
    return await http.customPost(url, data)
  },

  async redcatBind(payloads) {
    let url = `/v1/redcat/bind`
    return await http.post(url, payloads)
  },

  async redcatGetCategories(payloads) {
    let url = `/v1/redcat/category?siteId=${payloads.siteId}`

    return await http.get(url)
  },

  async redcatGetTerminals(payloads) {
    let url = `/v1/redcat/terminals?siteId=${payloads.siteId}`

    return await http.get(url)
  },

  async redcatCompleteBinding(payloads) {
    let url = `/v1/redcat/complete`

    return await http.post(url, payloads)
  },

  async redcatUnbinding() {
    let url = `/v1/redcat/unbind`

    return await http.post(url)
  },


  // Square Integration

  async squareBind(payloads) {
    let url = `/v1/square`
    return await http.post(url, payloads)
  },

  async getSquareCategories(payloads) {
    let url = `/v1/square/locations/${payloads.locationId}/categories`

    return await http.get(url)
  },

  async getSquareTerminals(payloads) {
    let url = `/v1/square/locations/${payloads.locationId}/devices`

    return await http.get(url)
  },

  async squareCompleteBinding(payloads) {
    let url = `/v1/square`
    return await http.put(url, payloads)
  },

  async squareUnbinding() {
    let url = `/v1/square`

    return await http.delete(url)
  },

  // Oolio Integration

  async oolioBind(payloads) {
    let url = `/revenue/oolio/v1/bind`
    return await http.post(url, payloads)
  },

  async oolioUnbinding() {
    let url = `/revenue/oolio/v1/bind`
    return await http.delete(url)
  },

  async oolioCompleteBinding(payloads) {
    let url = `/revenue/oolio/v1/bind`
    return await http.put(url, payloads)
  },

  async getOolioLocations(payloads) {
    let url = `/revenue/oolio/v1/${payloads.locationId}/locations`
    return await http.get(url, payloads)
  },

  async getOolioCategories(payloads) {
    let url = `/revenue/oolio/v1/${payloads.locationId}/categories`
    return await http.get(url, payloads)
  },



  async csvUploadBinding (type='idealpos', payloads) {
    let url = `/revenue/${type}/v1/bind-csv`

    if (type == 'oolio') {
      url = `/revenue/${type}/v1/bind`
    }

    return await http.post(url, payloads)
  },
  async csvUploadUnBinding (type='idealpos') {
    let url = `/revenue/${type}/v1/bind-csv`
    
    if (type == 'oolio') {
      url = `/revenue/${type}/v1/bind`
    }

    return await http.delete(url)
  },

  async keyPayUnbinding() {
    const venueId = sessionStorage.getItem('subVenueId')
    let url = `/venue/v1/venues/${venueId}/keypay/unbind`
    const res = await fetchInstance(url,{
      method: 'DELETE'
    })  
    return await res.json() 
  },

  // SwiftPOS Integration
  async swiftPosBind(payloads) {
    let url = `/v1/swiftpos`
    return await http.post(url, payloads)
  },

  async swiftPosUnbinding() {
    let url = `/v1/swiftpos`
    return await http.delete(url)
  },

  async swiftPosCompleteBinding(payloads) {
    let url = `/v1/swiftpos`
    return await http.put(url, payloads)
  },

  async swiftPosCategories() {
    let url = `/v1/swiftpos/categories/options`
    return await http.get(url)
  },

  async swiftPosConfiguration() {
    let url = `/v1/swiftpos/configuration`
    return await http.get(url)
  },

  async fetchEosDailyReport() {
    const venueId = sessionStorage.getItem('subVenueId')
    let url = `/eos/v1/venues/eos/entries/${venueId}`
    let res = await fetchInstance(url)

    if (res.status === 200) {
      return await res.json()
    }

    return [];
  },

  async fetchEosDailyReportByDate(date) {
    const venueId = sessionStorage.getItem('subVenueId')
    let url = `/eos/v1/venues/eos/entry/${venueId}?date=${date}`
    let res = await fetchInstance(url)

    if (res.status === 200) {
      return await res.json()
    }
    
    return null;
  },

  async getEosShifts(date) {
    const venueId = sessionStorage.getItem('subVenueId')
    const res = await fetchInstance(`/venue/v1/venues/${venueId}/shifts?date=${date}`)
    const data = await res.json()

    if (res.ok) {
        return data
    } else {
        if (data.message) {
            utils.alert('', data.message, 'error')
        } else {
            utils.alert('', 'Something went wrong, Please try again later', 'error')
        }
    }

},

}




// WEBPACK FOOTER //
// ./src/api/api.js